

function getVisualizerSettings( visualizerId) { // TODO
  console.log( visualizerId); // Aqui se debe obtener la informacion del visualizador indicado por visualizerId
  let settings = {
    // legacy: false,    // undefined evalua a falso
    visualizerType: 'Live',   // Esto debe obtenerse de la informacion del visualizador
    playerId: '',             // Esto debe obtenerse de la informacion del visualizador
    // mediaOriginId: '',        // Esto debe obtenerse de la informacion del visualizador
    // playlistId: '',           // Esto debe obtenerse de la informacion del visualizador
  };
  return new Promise( (resolve) => {
    resolve( settings);
  });
};

export default getVisualizerSettings;



// WEBPACK FOOTER //
// ./src/helpers/get-visualizer-settings.js